import { api } from '@creditsights/api-ui-web';
import { DealReportDto } from '../dtos/dealReport/dealReport.dto';

export const daagModuleV1Uri = '/common/v1/docscore/daag';

export const fetchDealReport = async (reportId: number | null): Promise<DealReportDto> => {
  const { data } = await api.get<DealReportDto>(`${daagModuleV1Uri}/${reportId}`);
  return data;
};

export const fetchDownloadDealReport = async (reportId: number | null): Promise<Blob> => {
  const { data } = await api.get<Blob>(`${daagModuleV1Uri}/${reportId}/download`, { responseType: 'blob' });
  return data;
};
